import React from "react";

const OurServices = () => {
  return (
    <section id="services" style={{ padding: "60px 0 40px" }}>
      <div className="container">
        <h2 className="section-title">Our All-in-One Services</h2>
        <p className="section-sub">
          Fast, reliable &amp; rewarding recharges and bill payments across
          India.
        </p>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-mobile-alt" />
            </div>
            <h3>Mobile Recharge</h3>
            <p>
              We offers quick, secure mobile recharges for all major telecom
              operators in India, ensuring seamless connectivity anytime,
              anywhere.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-tv" />
            </div>
            <h3>DTH Recharge</h3>
            <p>
              We provides fast and easy DTH recharges for all major service
              providers, ensuring uninterrupted entertainment at your
              convenience.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <i className="fab fa-google-play" />
            </div>
            <h3>Google Play Recharge</h3>
            <p>
              We offers quick and secure Google Play recharges, giving you
              instant access to apps, games, and more, anytime you need.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-receipt" />
            </div>
            <h3>Utility Bill Payments</h3>
            <p>
              We provide fast and secure bill payment services for electricity,
              water, gas, and more—ensuring hassle-free and timely payments at
              your convenience.
            </p>
          </div>
          {/* <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-gift" />
            </div>
            <h3>Brand Vouchers</h3>
            <p>
              We offer instant brand vouchers for top brands, making gifting and
              shopping easy, secure, and convenient anytime.
            </p>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
